import {l} from "types/typescriptdefinisjoner_lederplan";
import {BasisRessurs} from "felles/infrastruktur/BasisRessurs";
import {RessursFeilhåndtering} from "../RessursFeilhåndtering";
import {gettextCatalog} from "angular-gettext";
import _ from "lodash";
import {regNavn} from "../tredjepartsTjenestenavn";
import {Debugger} from "debug";

const debug: Debugger = require('debug')('SøkRessurs');

export class SøkRessurs extends BasisRessurs<l.SearchResponse> {
    static regNavn = "SøkRessurs";

    static forInjisering() {
        return [
            regNavn.ng.$resource,
            RessursFeilhåndtering.regNavn,
            regNavn.gettext.gettextCatalog,
            SøkRessurs
        ]
    }

    constructor($resource: ng.resource.IResourceService, ressursFeilhåndtering: RessursFeilhåndtering, gettextCatalog: gettextCatalog) {
        super("soek", $resource, ressursFeilhåndtering, gettextCatalog, {
            søk: {method: 'POST', url: "/api/soek"},
            finnEntiteter: {method: 'POST', url: "/api/soek/finnEntiteter"},
            søkAdmin: {method: 'POST', url: "/api/soek/admin"},
            finnLiknende: {method: 'GET', url: '/api/soek/finnLiknende'},
            finnLiknendeDokumentversjoner: {method: 'GET', url: '/api/soek/finnliknende/dokumentversjon/:id', params: {id: '@id'}, isArray: true}
        });
    }

    søk(søkestreng: string): l.SearchResponse {
        debug("SøkRessurs.søk", søkestreng);
        return this.ressurs['søk'](
            {soekestreng: søkestreng},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke søke")));
    }

    søkAvansert(spesifikasjon: l.SøkSpesifikasjon): l.SearchResponse {
      debug("SøkRessurs.søkAvansert", JSON.stringify(spesifikasjon));
      return this.ressurs['søk'](
        spesifikasjon,
        _.noop,
        this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke søke")));
    }

    søkAdmin(spesifikasjon: l.SøkSpesifikasjon): l.AngularRessurs<l.SearchResponse> {
        debug("SøkRessurs.søkAdmin", JSON.stringify(spesifikasjon));
        return this.ressurs['søkAdmin'](
            spesifikasjon,
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke søke")));
    }

    finnEntiteter(spesifikasjon: l.SøkEntitetSpesifikasjon): l.SearchResponse {
        debug("SøkRessurs.finnEntiteter", spesifikasjon);
        return this.ressurs['finnEntiteter'](
            spesifikasjon,
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke søke")));
    }

    finnLiknende(entitetId: string, entitetType: string): l.SearchResponse {
        debug("SøkRessurs.finnLiknende", entitetId, entitetType);
        return this.ressurs['finnLiknende'](
            {id: entitetId, type: entitetType},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne liknende elementer")));
    }

    finnLiknendeDokumentversjoner(dokumentVersjonId: string): l.LiknendeDokumentModell[] {
        debug("SøkRessurs.finnLiknendeDokumentversjoner", dokumentVersjonId);
        return this.ressurs['finnLiknendeDokumentversjoner'](
            {id: dokumentVersjonId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne liknende dokumenter")));
    }
}
